export default {
  loading: '/loading',
  notFound: '/stranka-nenajdena',
  tezaurus: {
    list: '/terminy',
    detail: {
      raw: '/terminy/:uuid',
      withParams: (uuid?: string): string => `/terminy/${uuid}`,
    },
    admin: {
      list: '/admin/tezaurus',
      create: '/admin/tezaurus/vytvorenie',
      edit: {
        raw: '/admin/tezaurus/:uuid/uprava',
        withParams: (uuid?: string): string => `/admin/tezaurus/${uuid}/uprava`,
      },
      termin: {
        list: {
          raw: '/admin/tezaurus/:tezaurusUuid/terminy',
          withParams: (tezaurusUuid?: string): string => `/admin/tezaurus/${tezaurusUuid}/terminy`,
        },
        create: {
          raw: '/admin/tezaurus/:uuid/terminy/vytvorenie',
          withParams: (uuid?: string): string => `/admin/tezaurus/${uuid}/terminy/vytvorenie`,
        },
        detail: {
          raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid',
          withParams: (tezaurusUuid?: string, terminUuid?: string):
            string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}`,
        },
        edit: {
          termin: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/uprava',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/uprava`,
          },
          doktrinalneDefinicie: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/uprava-doktrinalne-definicie',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/uprava-doktrinalne-definicie`,
          },
          legalneDefinicie: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/uprava-legalne-definicie',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/uprava-legalne-definicie`,
          },
          previazaneTerminy: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/uprava-previazane-terminy',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/uprava-previazane-terminy`,
          },
          poznamka: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/uprava-poznamka',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/uprava-poznamka`,
          },
          zaznamySekcie: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/judikaty-a-suzhodnutia-sudov',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/judikaty-a-suzhodnutia-sudov`,
          },
          pouzitieVPredpisoch: {
            raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/pouzitie-v-predpisoch',
            withParams: (tezaurusUuid?: string, terminUuid?: string):
              string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/pouzitie-v-predpisoch`,
          },
        },
        historiaZmien: {
          raw: '/admin/tezaurus/:tezaurusUuid/terminy/:terminUuid/historia-zmien',
          withParams: (tezaurusUuid?: string, terminUuid?: string):
            string => `/admin/tezaurus/${tezaurusUuid}/terminy/${terminUuid}/historia-zmien`,
        },
      },
    },
  },
};
